export const DispatchTypes = {
    courier: 'courier_office',
    organisation: 'organisation_office'
}